import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Welcome from "./Component/welcome";
import Login from "./Component/login";
import Navbar from "./Component/navbar";
import Menu from "./Component/menu";
import Barcode from "./Component/pages/Barcode";
import Profile from "./Component/pages/Profile";
import Settlements from "./Component/pages/Settlements";
import Transactions from "./Component/pages/Transactions";
import Complaints from "./Component/pages/Complaints";
import ChatRooms from "./Component/pages/ChatRooms";
import CompleteData from "./Component/pages/CompleteData";
import DinaCode from "./Component/pages/DinaCode";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";

class DinapartAPP extends Component {
  constructor(props) {
    // console.log("APP-Constructor");
    super(props);
    this.getBudget = this.getBudget.bind(this);
    this.saveSerialForUser = this.saveSerialForUser.bind(this);
    this.getCity = this.getCity.bind(this);
  }

  state = {
    blocking: false,
    isPaused: false,
    isModal: false,
    isError: false,
    isFamiliar: false,
    isSettlment: false,
    errorMessage: "",
    userJson: [],
    snNumberComplaint: "",
    transactionJson: [],
    settlementJson: [],
    complaintsJson: [],
    chatroomJson: [],
    town: [],
    city: [],
    moduleJson: [],
    budget: "در حال بروزرسانی",
    budgetFamiliar: "در حال بروزرسانی",
    budgetGift: "در حال بروزرسانی",
    unSeen: 0
  };

  componentDidMount() {
    console.log("APP-Mounted");
    const parms = window.location.pathname;
    if (parms === "/" || parms === "/login") return;
    else if (parms === "/checkData") {
      this.getFullProfile();
      this.getStates();
    } else {
      if (localStorage.getItem("token") === null)
        return (window.location = "/login");
      this.getFullProfile();
      this.getUserSerials();
      this.getUserSettlements(1);
      this.getUserComplaints(1);
      this.getStates();
      this.getMoudleDetails();
      this.getChatMessageUnseen();
    }
  }
  handleVideoEnded = () => {
    // localStorage.setItem(
    //   "token",
    //   ""
    // );
    if (localStorage.getItem("token") === null)
      return (window.location = "/login");
    return (window.location = "/home");
  };

  handleLogin = (e) => {
    localStorage.setItem("token", e.data.token);
    if (e.needCheckData) return (window.location = "/checkData");
    else return (window.location = "/home");
  };

  handleLouOut = () => {
    const token = localStorage.getItem("token");
    if (token != null) {
      localStorage.clear();
      return (window.location = "/");
    }
  };
  toggleSettlment = () => {
    this.setState({ isSettlment: !this.state.isSettlment });
  };
  toggleFamiliar = () => {
    this.setState({ isFamiliar: !this.state.isFamiliar });
  };
  toggleBlocking = () => {
    this.setState({ blocking: !this.state.blocking });
  };
  toggleModal = () => {
    this.setState({ isModal: !this.state.isModal });
  };
  toggleErrorMessage = (e) => {
    if (e !== null) this.setState({ errorMessage: e });
  };
  toggleError = () => {
    this.setState({ isError: !this.state.isError });
  };
  render() {
    if (
      localStorage.getItem("token") === null &&
      window.location.pathname !== "/login"
    )
      return (
        <div className="container-fluid body">
          <div className="row">
            <Welcome handleVideoEnded={this.handleVideoEnded} />
          </div>
        </div>
      );
    else {
      return (
        // <Router>
        <div className="container-fluid body">
          <div className="row">
            <Modal show={this.state.isFamiliar} onHide={this.toggleFamiliar}>
              <Modal.Header closeButton>
                <Modal.Title>شبکه تعمیرکاران دیناپارت</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="w-100 text-justify text">
                  <p className="mb-0">
                    تعمیرکار گرامی، کد معرف خود را وارد نمایید. بعد از ثبت امکان
                    تغییر آن وجود ندارد
                  </p>
                </div>
                <div className="w-100 SN-box">
                  <label className="dina-fc-orange">کد معرف</label>
                  <input
                    type="text"
                    className="form-control"
                    id="FamiliarCode_Register"
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-sm dina-btn-orange"
                  onClick={this.handleFamiliarCode}
                >
                  تایید
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal show={this.state.isError} onHide={this.toggleError}>
              <Modal.Header closeButton>
                <Modal.Title>شبکه تعمیرکاران دیناپارت</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="w-100 text-justify text">
                  <p className="mb-0">{this.state.errorMessage}</p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-sm dina-btn-orange"
                  onClick={this.toggleError}
                >
                  تایید
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal show={this.state.isModal} onHide={this.toggleModal}>
              <Modal.Header closeButton>
                <Modal.Title>بارکد را وارد کنید:</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="w-100 text-justify text">
                  <p className="mb-0">
                    تعمیرکار گرامی، این محصول قبلا در سامانه به ثبت رسیده است.
                  </p>
                  <p className="mb-0">
                    درصورت اطمینان می‌توانید ثبت شکایت نمایید.
                  </p>
                </div>
                <div className="w-100 SN-box">
                  <label className="dina-fc-orange">بارکد</label>
                  <input
                    type="text"
                    className="form-control"
                    id="ComplaintSN"
                    defaultValue={this.state.snNumberComplaint}
                    onChange={(e) =>
                      this.setState({ snNumberComplaint: e.target.value })
                    }
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-sm dina-btn-orange"
                  onClick={this.addComplaint}
                >
                  ثبت شکایت
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal show={this.state.isSettlment} onHide={this.toggleSettlment}>
              <Modal.Header closeButton>
                <Modal.Title>درخواست خود را تکمیل کنید:</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="w-100 text-justify text">
                  <div className="alert alert-warning small p-1 text-center">
                    تعمیرکار گرامی، حداقل موجودی کیف پول برای ثبت درخواست تسویه کامل یک میلیون ریال می‌باشد.
                  </div>
                  <p className="mb-0 text-center font-weight-bold">
                    نوع درخواست تسویه را مشخص کنید:
                  </p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-sm dina-btn-blue"
                  onClick={() => this.handleSettlement('GiftCode')}
                >
                  تسویه هدایا
                </Button>
                <Button
                  className="btn btn-sm dina-btn-orange"
                  onClick={() => this.handleSettlement('Wallet')}
                >
                  تسویه کامل                </Button>
              </Modal.Footer>
            </Modal>
            <Switch>
              <Route path="/" exact>
                <Welcome handleVideoEnded={this.handleVideoEnded} />
              </Route>
              <Route path="/login" exact>
                <Login
                  handleLogin={this.handleLogin}
                  toggleError={this.toggleError}
                  toggleErrorMessage={this.toggleErrorMessage}
                />
              </Route>
              <Route path="/checkData" exact>
                <CompleteData
                  getCity={this.getCity}
                  city={this.state.city}
                  town={this.state.town}
                  saveFullProfile={this.saveFullProfile}
                  userJson={this.state.userJson}
                  toggleError={this.toggleError}
                  toggleErrorMessage={this.toggleErrorMessage}
                />
              </Route>
              <Route path="/chat" exact>
                <ChatRooms
                  getChatMessageUnseen={this.getChatMessageUnseen}
                  toggleError={this.toggleError}
                  toggleErrorMessage={this.toggleErrorMessage}
                  chatroomJson={this.state.chatroomJson}
                />
                <div className="col-12 p-0 fixed-bottom bg-light py-1">
                  <Menu></Menu>
                </div>
              </Route>
              <Route path="/profile">
                <div className="col-12 feed-body">
                  <Profile
                    getCity={this.getCity}
                    city={this.state.city}
                    town={this.state.town}
                    saveFullProfile={this.saveFullProfile}
                    userJson={this.state.userJson}
                    toggleFamiliar={this.toggleFamiliar}
                    toggleError={this.toggleError}
                    toggleErrorMessage={this.toggleErrorMessage}
                    handleLouOut={this.handleLouOut}
                  ></Profile>
                </div>
                <div className="col-12 p-0 fixed-bottom bg-light py-1">
                  <Menu></Menu>
                </div>
              </Route>
              <Route path="/transaction">
                <div className="col-12 p-0 fixed-top nav-height">
                  <Navbar
                    toggleSettlment={this.toggleSettlment}
                    userJson={this.state.userJson}
                    budget={this.state.budget}
                    budgetFamiliar={this.state.budgetFamiliar}
                    budgetGift={this.state.budgetGift}
                  ></Navbar>
                </div>
                <div className="col-12 feed-body">
                  <Transactions
                    transactionJson={this.state.transactionJson}
                  ></Transactions>
                </div>
                <div className="col-12 p-0 fixed-bottom bg-light py-1">
                  <Menu></Menu>
                </div>
              </Route>
              <Route path="/dina-code">
                <div className="col-12 p-0 fixed-top nav-height">
                  <Navbar
                    toggleSettlment={this.toggleSettlment}
                    userJson={this.state.userJson}
                    budget={this.state.budget}
                    budgetFamiliar={this.state.budgetFamiliar}
                    budgetGift={this.state.budgetGift}
                  ></Navbar>
                </div>
                <div className="col-12 feed-body">
                  <DinaCode toggleError={this.toggleError}
                    toggleErrorMessage={this.toggleErrorMessage}
                  ></DinaCode>
                </div>
                <div className="col-12 p-0 fixed-bottom bg-light py-1">
                  <Menu></Menu>
                </div>
              </Route>
              <Route path="/settlement">
                <div className="col-12 p-0 fixed-top nav-height">
                  <Navbar
                    toggleSettlment={this.toggleSettlment}
                    userJson={this.state.userJson}
                    budget={this.state.budget}
                    budgetFamiliar={this.state.budgetFamiliar}
                    budgetGift={this.state.budgetGift}
                  ></Navbar>
                </div>
                <div className="col-12 feed-body">
                  <Settlements settlementJson={this.state.settlementJson}></Settlements>
                </div>
                <div className="col-12 p-0 fixed-bottom bg-light py-1">
                  <Menu></Menu>
                </div>
              </Route>
              <Route path="/complaints">
                <div className="col-12 p-0 fixed-top nav-height">
                  <Navbar
                    toggleSettlment={this.toggleSettlment}
                    userJson={this.state.userJson}
                    budget={this.state.budget}
                    budgetFamiliar={this.state.budgetFamiliar}
                    budgetGift={this.state.budgetGift}
                  ></Navbar>
                </div>
                <div className="col-12 feed-body">
                  <Complaints
                    toggleModal={this.toggleModal}
                    complaintsJson={this.state.complaintsJson}
                  ></Complaints>
                </div>
                <div className="col-12 p-0 fixed-bottom bg-light py-1">
                  <Menu></Menu>
                </div>
              </Route>
              <Route path="/home">
                <div className="main-body">
                  <BlockUi tag="div" blocking={this.state.blocking}>
                    <div className="col-12 p-0 fixed-top nav-height">
                      <Navbar
                        toggleSettlment={this.toggleSettlment}
                        userJson={this.state.userJson}
                        budget={this.state.budget}
                        budgetFamiliar={this.state.budgetFamiliar}
                        budgetGift={this.state.budgetGift}
                      ></Navbar>
                    </div>
                    <div className="col-12 feed-body">
                      <div className="row">
                        <Route path="/home" exact>
                          <Barcode
                            moduleJson={this.state.moduleJson}
                            toggleError={this.toggleError}
                            toggleErrorMessage={this.toggleErrorMessage}
                            unSeen={this.state.unSeen}
                            saveSerialForUser={this.saveSerialForUser}
                            addComplaintFile={this.addComplaintFile}
                          ></Barcode>
                        </Route>
                      </div>
                    </div>
                    <div className="col-12 p-0 fixed-bottom bg-light py-1 nav-height">
                      <Menu></Menu>
                    </div>
                  </BlockUi>
                </div>
              </Route>
            </Switch>
          </div>
        </div>
        // </Router>
      );
    }
  }

  handleFamiliarCode = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var FamiliarCode = document.getElementById("FamiliarCode_Register").value;
      if (FamiliarCode !== null && FamiliarCode.length === 8) {
        this.toggleBlocking();
        var formdata = new FormData();
        formdata.append("token", token);
        formdata.append("Key", FamiliarCode);
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/add-familiarcode-request`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                this.toggleFamiliar();
                this.getFullProfile();
                this.toggleBlocking();
                this.setState(
                  { errorMessage: "کد معرف در پروفایل کاربری شما ثبت گردید." },
                  function () {
                    this.toggleError();
                  }
                );
              } else {
                this.setState({ errorMessage: myObject.message }, function () {
                  this.toggleError();
                });
                this.toggleBlocking();
              }
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        this.setState(
          { errorMessage: "کد معرف وارد شده اشتباه است." },
          function () {
            this.toggleError();
          }
        );
      }
    }
  };

  handleSettlement = (e) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      this.toggleBlocking();
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("type", e);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };
      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/add-settlement-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { errorMessage: "درخواست تسویه شما در سامانه ثبت شد." },
                function () {
                  this.toggleError();
                  this.toggleSettlment();
                }
              );
              this.getBudget();
              this.getUserSettlements(1);
              this.toggleBlocking();
            } else {
              this.setState({ errorMessage: myObject.message }, function () {
                this.toggleError();
              });
              this.toggleBlocking();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  saveSerialForUser = (currentValue) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      const serialnumber_text = currentValue;
      if (
        serialnumber_text !== null &&
        serialnumber_text.length >= 9 &&
        serialnumber_text.length <= 21
      ) {
        this.toggleBlocking();
        var formdata = new FormData();
        formdata.append("token", token);
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };

        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/serials/save-serial-for-user?serial_number=${serialnumber_text}`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                this.setState(
                  { errorMessage: "بارکد با موفقیت ثبت شد." },
                  function () {
                    this.toggleError();
                  }
                );
                this.getUserSerials();
                this.getBudget();
                this.toggleBlocking();
              } else if (myObject.status === 2) {
                this.setState({ errorMessage: myObject.message }, function () {
                  this.toggleError();
                });
                // this.setState(
                //   { snNumberComplaint: serialnumber_text },
                //   function() {
                //     this.addComplaint();
                //   }
                // );
                this.toggleBlocking();
              } else if (myObject.status === 1) {
                this.toggleBlocking();
                this.setState(
                  { snNumberComplaint: serialnumber_text },
                  function () {
                    this.toggleModal();
                  }
                );
              } else if (myObject.status === 3) {
                this.setState({ errorMessage: myObject.message }, function () {
                  this.toggleError();
                });
                this.toggleBlocking();
              }
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        this.setState(
          { errorMessage: "بارکد وارد شده اشتباه است." },
          function () {
            this.toggleError();
          }
        );
      }
    }
  };

  addComplaintFile = (e) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      this.toggleBlocking();
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("sn_file", e);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/complaints/add-complaint-file`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              if (this.state.isError !== true) {
                this.setState(
                  {
                    errorMessage:
                      "تعمیرکار گرامی؛ تصویر بارکد محصول شما برای کارشناسان ما ارسال گردید، بعد از بررسی در حساب کاربری شما ثبت خواهد شد.",
                  },
                  function () {
                    this.toggleError();
                    this.toggleBlocking();
                  }
                );
              }
            } else {
              this.setState({ errorMessage: myObject.message }, function () {
                this.toggleError();
                this.toggleBlocking();
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  addComplaint = () => {
    const token = localStorage.getItem("token");
    const sn = this.state.snNumberComplaint;
    if (token !== null && sn !== null) {
      this.toggleBlocking();
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/complaints/add-complaint?serial_number=${sn}`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          this.toggleBlocking();
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              if (this.state.isError !== true) {
                this.setState(
                  { errorMessage: "شکایت شما ثبت شد." },
                  function () {
                    this.toggleError();
                  }
                );
              }
              this.setState({ snNumberComplaint: null }, function () {
                if (this.state.isModal === true) this.toggleModal();
              });
              this.getUserComplaints(1);
            } else {
              this.setState({ errorMessage: myObject.message }, function () {
                this.toggleError();
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  getBudget() {
    const token = localStorage.getItem("token");
    // console.log("APP-Get Budget");
    if (token !== null) {
      // console.log("APP-Get Budget - start");
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/get-user-balance`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ budget: myObject.budget });
              this.setState({ budgetFamiliar: myObject.budgetFamiliar });
              this.setState({ budgetGift: myObject.budgetGift });
              //this.setState({budget: myObject.data}, function(){
              //if (this.state.isPaused === true) this.setState({isPaused: false});
              //});
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  }

  getFullProfile = () => {
    // console.log("APP-Get User Info");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/user/get-full-profile`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userJson: myObject.data }, function () {
                this.getBudget();
              });
              const parms = window.location.pathname;
              if (myObject.needCheckData && parms !== "/checkData")
                window.location.href = "/checkData";
            } else {
              if (myObject.message === "عدم مجوز جهت دریافت اطلاعات") {
                localStorage.clear();
              }
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };

  getUserSerials = () => {
    // console.log("APP-Get User Serials");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/serials/get-user-serials`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ transactionJson: myObject.data }, function () { });
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };

  getUserSettlements = (pageindex) => {
    // console.log("APP-Get User Settlements");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/get-user-settlements?page=1`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ settlementJson: myObject.data }, function () { });
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };

  getUserComplaints = (pageindex) => {
    // console.log("APP-Get User Complaints");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/complaints/get-user-complaints?page=1`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ complaintsJson: myObject.data }, function () { });
            }
          }
        })
        .catch((error) => console.log(error));
    }
  };

  saveFullProfile = (data) => {
    // console.log("APP-Edit User Data");
    const token = localStorage.getItem("token");
    if (token !== null) {
      let imgUser = document.getElementById("inputId");
      var formdata = new FormData();
      formdata.append("first_name", data.userForm.first_name);
      formdata.append("last_name", data.userForm.last_name);
      formdata.append("bank_name", data.userForm.bank_name);
      formdata.append("bank_shaba", data.userForm.bank_shaba);
      formdata.append("national_id", data.userForm.national_id);
      formdata.append("shop_name", data.userForm.shop_name);
      formdata.append("address", data.userForm.address);
      formdata.append("postal_code", data.userForm.postal_code);
      formdata.append("city_id", data.userForm.city_id);
      if (
        imgUser &&
        imgUser.files &&
        imgUser.files.length > 0 &&
        imgUser.files[0].size <= 4000000
      ) {
        formdata.append("profile_picture", imgUser.files[0]);
      }
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/user/save-full-profile`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { errorMessage: "اطلاعات با موفقیت به روزرسانی شد." },
                function () {
                  this.toggleError();
                }
              );
              this.setState({ userJson: myObject.data }, function () {
                // console.log("Edit User Successfully done!");
              });
              this.getFullProfile();
            } else {
              // console.log("Edit User Data : " + myObject.message);
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  getStates = () => {
    // console.log("APP-Get all town");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };
      fetch(`${process.env.REACT_APP_BASE_URL}/api/get-states`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ town: myObject.data }, function () {
                if (this.state.userJson.state_id !== null)
                  this.getCity(this.state.userJson.state_id);
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  getCity = (townID) => {
    let currentValue = null;
    try {
      currentValue = townID.target.value;
    } catch (error) {
      currentValue = townID;
    }
    // console.log("APP-Get all city");
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/get-cities?state_id=${currentValue}`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ city: myObject.data }, function () {
                this.setState({ state_id: currentValue });
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  getChatroom = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/get-chatroom`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ chatroomJson: myObject.data }, function () { });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  getMoudleDetails = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/get-moudle-details`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ moduleJson: myObject.data_array }, function () {
                //console.log(myObject.data);
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  getChatMessageUnseen = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/api/get-chatroom-messages-unseen`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ unSeen: myObject.data });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
}

export default DinapartAPP;
